import { useOktaAuth } from '@okta/okta-react';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { constants } from '../../constants';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { AuthUserContext } from '../../provider/AuthUserContextProvider';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { NotifyMessageLinkPage } from '../../ui-parts/NotifyMessageLinkPage';
import { utility } from '../../utility';

/**
 * StepPage Page Component
 */
const StepPage = () => {

  const screenId = 'MyM703';
  const apiRequest = useMyMApi(screenId);
  const { controlSettings, messageList } = useWebContext(screenId);
  const { authUser, setAuthUser } = useContext(AuthUserContext);
  const [cachedAuthUser, setCachedAuthUser] = useState(false);
  // 2025.3.5 MyMine Version2.1対応 Add Start
  const [isLoading, setIsLoading] = useState(false);
  // 2025.3.5 MyMine Version2.1対応 Add End
  const navigate = useNavigate();
  const { authState } = useOktaAuth();
  const location = useLocation();

  useEffect(() => {
    if (authState.isAuthenticated === false && !sessionStorage.getItem(constants.HttpStorageItemKey.DebugUserSsoKey)) {
      utility.transferTopPage();
    } else {
      if (authUser) {
        setCachedAuthUser(true);
      } else {
        const callbackRequestLogin = (result) => {
          if (result?.IsRegistered === true) {
            setAuthUser(result.User);

            if (result.User.StatusId === constants.UserStatus.Active ||
              result.User.StatusId === constants.UserStatus.ActiveAndCaution ||
              result.User.StatusId === constants.UserStatus.RequestingUploader) {
              if (result.NeedsCookieAcceptance === true) {
                navigate('/MyM702', { replace: true });
              }
              // 2025.3.5 MyMine Version2.1対応 Add Start
              // コンテンツシェア時はStateに暗号パラメータが入るため、復号して該当ページへ遷移
              else if (location.state !== null) {
                setIsLoading(true);
                apiRequest.requestJson(
                  `api/contents/decrypt-share-key?encryptShareKey=${location.state}`,
                  'GET',
                  (result) => {
                    navigate(
                      `/MyM102/${Array.isArray(result.ScreenIdList) && result.ScreenIdList.length > 0
                        ? result.ScreenIdList.join('/')
                        : ''
                      }${result.UrlMetadataId ? `/${result.UrlMetadataId}` : ''
                      }`,
                      { state: { contentsMetadataId: result.ContentsMetadataId, previewFileId: result.FileId } }
                    );
                  },
                  () => {
                    setIsLoading(false);
                  });
              }
              // 2025.3.5 MyMine Version2.1対応 Add End
              else {
                navigate('/MyM102', { replace: true });
              }
            }
          }
          setCachedAuthUser(true);
        };
        apiRequest.requestJson('authentication/login', 'POST', callbackRequestLogin);
      }
    }
  }, []);

  // 2025.3.5 MyMine Version2.1対応 Modify Start
  if (!cachedAuthUser || isLoading) {
    return <MyMProgress />;
  }
  // 2025.3.5 MyMine Version2.1対応 Modify End

  const linkMessageProps = {};

  if (!authUser) {
    linkMessageProps.message = messageList.MyM_MSG_I_0062;
    linkMessageProps.linkText = controlSettings.LabelList.lnkTransitionsUserRegistration;
    linkMessageProps.navigateTo = '/MyM201';
  } else {
    switch (authUser.StatusId) {
      case constants.UserStatus.Requesting:
        linkMessageProps.message = messageList.MyM_MSG_I_0063;
        linkMessageProps.linkText = controlSettings.LabelList.lnkTransitionsTop;
        linkMessageProps.onClick = utility.transferTopPage;
        break;
      case constants.UserStatus.Rejected:
        linkMessageProps.message = messageList.MyM_MSG_I_0065;
        linkMessageProps.linkText = controlSettings.LabelList.lnkTransitionsUserRegistration;
        linkMessageProps.navigateTo = '/MyM201';
        break;
      case constants.UserStatus.Approved:
        linkMessageProps.message = messageList.MyM_MSG_I_0064;
        linkMessageProps.linkText = controlSettings.LabelList.lnkTransitionsTop;
        linkMessageProps.onClick = utility.transferTopPage;
        break;
      default:
        throw new Error("Incorrect user status.")
    }
  }
  if (location?.state?.result?.PostResult === false) {
    linkMessageProps.message = messageList.MyM_MSG_E_0138;
    linkMessageProps.linkText = controlSettings.LabelList.lnkTransitionsTop;
    linkMessageProps.onClick = utility.transferTopPage;
    linkMessageProps.navigateTo = null;
  }
  return (
    <NotifyMessageLinkPage {...linkMessageProps} />
  );
};
export default StepPage;
